<template>
  <div class="flex flex-col items-center mb-10">
    <button
      @click="mostrarModal = true"
      class="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
    >
      Descargar plantilla de Excel para carga de usuarios (Staff, Expositores, Asistentes)
    </button>

    <div v-if="mostrarModal" class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div class="bg-white p-6 rounded shadow-lg w-full max-w-md">
        <h3 class="text-lg font-bold mb-2">Antes de descargar</h3>
        <p class="mb-4">Recuerda que: para este evento los campos obligatorios son los siguientes:</p>

        <ul class="list-disc list-inside text-sm mb-4">
          <li v-for="campo in camposFiltrados" :key="campo.label">
            {{ campo.label }}
          </li>
        </ul>

        <p class="text-sm text-gray-600 mb-4">Los otros campos (columnas) no son mandatorias y puedes dejarlas vacías si prefieres. </p>
        <p class="text-sm text-gray-600 mb-4">Por favor no elimines columnas ni cambies los títulos de las mismas. Gracias</p>

        <div class="flex justify-end gap-4">
          <button
            @click="descargar"
            class="bg-green-600 hover:bg-green-800 text-white px-4 py-2 rounded"
          >
            Descargar plantilla
          </button>
          <button
            @click="mostrarModal = false"
            class="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadButton',
  props: {
    camposObligatorios: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      mostrarModal: false
    };
  },
  computed: {
  camposFiltrados() {
    return this.camposObligatorios
      .filter(c => c.activo || c.requerido || c.mandatorio)
      .map(campo => {
        const label = campo.label.replace(/_/g, ' ');
        return {
          ...campo,
          label: label.charAt(0).toUpperCase() + label.slice(1)
        };
      });
  }
},

  methods: {
    descargar() {
      this.mostrarModal = false;
      const link = document.createElement('a');
      link.href = '/Plantilla para usuarios.xlsx';
      link.download = 'Plantilla para usuarios.xlsx';
      link.click();
    }
  }
};
</script>

<style scoped>
/* Opcional: mejora el fondo modal o animaciones */
ul {
  list-style: none;
  padding: 0;
}

button {

background: rgb(61, 67, 91)!important;
border-radius: 3px!important;
}

</style>
